/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PatchOrganizationCombosRequestInnerAllOfSchedulesInner } from './PatchOrganizationCombosRequestInnerAllOfSchedulesInner';
import {
    PatchOrganizationCombosRequestInnerAllOfSchedulesInnerFromJSON,
    PatchOrganizationCombosRequestInnerAllOfSchedulesInnerFromJSONTyped,
    PatchOrganizationCombosRequestInnerAllOfSchedulesInnerToJSON,
    PatchOrganizationCombosRequestInnerAllOfSchedulesInnerToJSONTyped,
} from './PatchOrganizationCombosRequestInnerAllOfSchedulesInner';
import type { PatchOrganizationCombosRequestInnerAllOfCategoriesInner } from './PatchOrganizationCombosRequestInnerAllOfCategoriesInner';
import {
    PatchOrganizationCombosRequestInnerAllOfCategoriesInnerFromJSON,
    PatchOrganizationCombosRequestInnerAllOfCategoriesInnerFromJSONTyped,
    PatchOrganizationCombosRequestInnerAllOfCategoriesInnerToJSON,
    PatchOrganizationCombosRequestInnerAllOfCategoriesInnerToJSONTyped,
} from './PatchOrganizationCombosRequestInnerAllOfCategoriesInner';

/**
 * 
 * @export
 * @interface PatchOrganizationCombosRequestInner
 */
export interface PatchOrganizationCombosRequestInner {
    /**
     * 
     * @type {string}
     * @memberof PatchOrganizationCombosRequestInner
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof PatchOrganizationCombosRequestInner
     */
    name?: string;
    /**
     * 
     * @type {number}
     * @memberof PatchOrganizationCombosRequestInner
     */
    price?: number;
    /**
     * 
     * @type {string}
     * @memberof PatchOrganizationCombosRequestInner
     */
    color?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PatchOrganizationCombosRequestInner
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PatchOrganizationCombosRequestInner
     */
    imageId?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof PatchOrganizationCombosRequestInner
     */
    hasSchedule?: boolean;
    /**
     * 
     * @type {Array<PatchOrganizationCombosRequestInnerAllOfCategoriesInner>}
     * @memberof PatchOrganizationCombosRequestInner
     */
    categories?: Array<PatchOrganizationCombosRequestInnerAllOfCategoriesInner>;
    /**
     * 
     * @type {boolean}
     * @memberof PatchOrganizationCombosRequestInner
     */
    enabled?: boolean;
    /**
     * 
     * @type {Array<PatchOrganizationCombosRequestInnerAllOfSchedulesInner>}
     * @memberof PatchOrganizationCombosRequestInner
     */
    schedules?: Array<PatchOrganizationCombosRequestInnerAllOfSchedulesInner>;
}

/**
 * Check if a given object implements the PatchOrganizationCombosRequestInner interface.
 */
export function instanceOfPatchOrganizationCombosRequestInner(value: object): value is PatchOrganizationCombosRequestInner {
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function PatchOrganizationCombosRequestInnerFromJSON(json: any): PatchOrganizationCombosRequestInner {
    return PatchOrganizationCombosRequestInnerFromJSONTyped(json, false);
}

export function PatchOrganizationCombosRequestInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): PatchOrganizationCombosRequestInner {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'price': json['price'] == null ? undefined : json['price'],
        'color': json['color'] == null ? undefined : json['color'],
        'description': json['description'] == null ? undefined : json['description'],
        'imageId': json['imageId'] == null ? undefined : json['imageId'],
        'hasSchedule': json['hasSchedule'] == null ? undefined : json['hasSchedule'],
        'categories': json['categories'] == null ? undefined : ((json['categories'] as Array<any>).map(PatchOrganizationCombosRequestInnerAllOfCategoriesInnerFromJSON)),
        'enabled': json['enabled'] == null ? undefined : json['enabled'],
        'schedules': json['schedules'] == null ? undefined : ((json['schedules'] as Array<any>).map(PatchOrganizationCombosRequestInnerAllOfSchedulesInnerFromJSON)),
    };
}

export function PatchOrganizationCombosRequestInnerToJSON(json: any): PatchOrganizationCombosRequestInner {
    return PatchOrganizationCombosRequestInnerToJSONTyped(json, false);
}

export function PatchOrganizationCombosRequestInnerToJSONTyped(value?: PatchOrganizationCombosRequestInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'price': value['price'],
        'color': value['color'],
        'description': value['description'],
        'imageId': value['imageId'],
        'hasSchedule': value['hasSchedule'],
        'categories': value['categories'] == null ? undefined : ((value['categories'] as Array<any>).map(PatchOrganizationCombosRequestInnerAllOfCategoriesInnerToJSON)),
        'enabled': value['enabled'],
        'schedules': value['schedules'] == null ? undefined : ((value['schedules'] as Array<any>).map(PatchOrganizationCombosRequestInnerAllOfSchedulesInnerToJSON)),
    };
}

